import { env, bridge, monitor, runtime } from '@/common';
import { fetchMainpageData, fetchLatestBalance, fetchQuestionList } from '@/service/fetchIndexData';
import { EventBus } from '@/service/eventBus';
import { prefetchApiWithTimeout } from '@/service/fetchIndexData';
import { MGM_HOST } from '@/common/constant';

// DSP接口地址
const DSP_BALANCE_URL = `${MGM_HOST[runtime]}/marketing/sdk/prefetch/balance`;


/**
 * @fn 余额预取dsp逻辑
 * 预取DSP实验组：预取+dsp：预取请求 -> dsp请求降级 -> 各自调用http接口
 * 主动降级：downgrade为true -> 各自调用http接口
 * 预取+DSP实验组成功率计算：预取dsp接口请求成功 / （预取dsp接口请求成功 + 预取dsp接口请求失败）
 */
export async function ehcDspPage() {
    if (env.isWechat) {
        await downgradeHandler();
    } else {
        try {
            const res = await Promise.all([
                prefetchApiWithTimeout(DSP_BALANCE_URL),
                fetchQuestionList()
            ]);
            await handlePageData(res[0]);
            monitor.captureMessage({ name: '预取dsp接口请求成功' });
        } catch (err) {
            monitor.captureMessage({ name: err?.message || '预取dsp接口请求失败', msg: err });
            await downgradeHandler();
        }
    }
}

/**
 * @param {object} res dsp聚合数据
 */
async function handlePageData (res) {
    if(res.status === 'success' && !res.downgrade) {
        const { mainData = {}, accountDetail = {}, pgyData = {} } = res || {}
        env.setIndexData(mainData);
        EventBus.$emit('updatePageData');
        EventBus.$emit('setLatestBalanceDetail', accountDetail);
        env.setPgyData(pgyData);
        pageShow();
    } else {
        await downgradeHandler(res);
    }
}
/**
 * @fn 降级请求【主接口、明细接口、小钱罐】
 */
async function downgradeHandler (res) {
    const { pgyData = {} } = res || {}
    env.setPgyData(pgyData);
    await Promise.all([
        fetchMainpageData(),
        fetchLatestBalance(),
        fetchQuestionList()
    ]).finally(() => {
        pageShow();
    })
}

/**
 * @fn 页面展示，抵达率上报&TTI上报
 */
export function pageShow() {
    bridge.ehShow();
    EventBus.$emit('pageApiReady');
    monitor.sendPointCustomApi({
        position: 23,
    });
}


